import { useParams } from "react-router-dom";

export const useCommentId = () => {
	const { commentId } = useParams<{ commentId : string }>();

	if (!commentId) {
		throw new Error("commentId is required in URL params");
	}

	return { commentId };
};
